import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-attribution',
  templateUrl: './attribution.component.html',
  styleUrls: ['./attribution.component.css']
})
export class AttributionComponent implements OnInit{
  dependencies: any;

  constructor() {
  }

  ngOnInit() {
  }
}
